/* eslint-disable @intercom/intercom/no-bare-strings */

import { guidFor } from '@ember/object/internals';
import { uploadResultToNodeAttrs } from '@intercom/embercom-prosemirror-composer/lib/config/specs/decorators';
import { applyNewAttrsToFileNode, findNodeByFileGUID } from '@intercom/embercom-prosemirror-composer/lib/helpers/file';
export function updateAudioFileNodeWithUploadResults({
  editorView,
  AudioUploadResult
}) {
  let pos = findNodeByFileGUID(editorView, guidFor(AudioUploadResult.file));
  if (pos.fileNode) {
    let attrs = {
      ...pos.fileNode.attrs
    };
    let failure = [AudioUploadResult].find(r => r.type !== 'success');
    if (failure) {
      attrs = {
        ...attrs,
        ...uploadResultToNodeAttrs(failure)
      };
    } else if (AudioUploadResult.type === 'success') {
      attrs = {
        ...attrs,
        ...uploadResultToNodeAttrs(AudioUploadResult),
        url: AudioUploadResult.uploadUrl
      };
    }
    applyNewAttrsToFileNode(editorView, pos, attrs);
  }
}